import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { ErrorTranslateService } from '../error-translate-service';
import { BaseFormErrorTranslateService } from '../form-common-error/base-form-error-translate.service';

@Component({
  selector: 'sd-form-error',
  templateUrl: './form-error.component.html',
  standalone: true,
  imports: [],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
/**
 * Error display component
 */
export class SdFormErrorComponent {
  @Input()
  control: AbstractControl;

  /**
   * WARNING: it looks like angular return validators as lowercase !!
   * for example 'minLength' become 'minlength' and so on!
   */
  @Input()
  errorKey: string;

  @Input()
  errorLabel: string;

  get invalid(): boolean {
    const control = this.control;
    return (
      control.invalid && control.touched && control.hasError(this.errorKey)
    );
  }
}
